import { useEffect, useState } from "react";
import { MiDetailPageHeader, MiTab } from "@miplatform/components";
import { useRouter } from "@miplatform/hooks";
import { mdiChevronLeft } from "@mdi/js";
import { CommunitiesTab } from "./CommunitiesTab/CommunitiesTab";
import { CITY_DETAILS_TABS, CITY_DETAILS_TABS_NAMES } from "./cityDetailsTabs";
import { useCityDetailsViewModel } from "./useCityDetailsViewModel";

export function CityDetails() {
  const {
    params: { id: cityId },
  } = useRouter();
  const [activeTab, setActiveTab] = useState(
    CITY_DETAILS_TABS_NAMES.COMMUNITIES
  );
  const {
    isLoading,
    city,
    communities,
    setCommunities,
    getCommunities,
    getCity,
  } = useCityDetailsViewModel();

  useEffect(() => {
    getCity(cityId);
  }, [cityId]);

  return (
    <>
      <MiDetailPageHeader
        title={`City: ${city?.cityName}, ${city?.regionCode}`}
        titleIcon={mdiChevronLeft}
        loading={isLoading}
      />
      <MiTab
        tabs={CITY_DETAILS_TABS}
        currentTab={activeTab}
        onTabChange={setActiveTab}
      />
      {activeTab === CITY_DETAILS_TABS_NAMES.COMMUNITIES && city?.cityName && (
        <CommunitiesTab
          isLoading={isLoading}
          communities={communities}
          setCommunities={setCommunities}
          getCommunities={getCommunities}
        />
      )}
    </>
  );
}
